<template>
  <div class="page-collect" :class="{'mobile': _isMobile}">
    <div class="collect-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="4"></cmpBanner>

      <div class="g-wrap">
        <cmpTab :tabs="tabList" :activeVal="activeVal" :subHeight="'760px'" @eventTabClick="eventTabClick"></cmpTab>

        <div class="g-content">
          <!-- 搜索条件 -->
          <div class="com-list-header" v-if="activeVal==='1'||activeVal==='3'||activeVal==='4'">
            <el-form class="search-box" ref="form" :model="form" label-width="0">
              <el-form-item label="" prop="name">
                <el-input v-model="form.name" clearable placeholder="搜索文物名称"></el-input>
              </el-form-item>

              <el-form-item label="" prop="year">
                <el-select v-model="form.year" filterable clearable placeholder="文物年代" style="width:100%;">
                  <el-option
                    v-for="item in yearList"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="" prop="type" v-if="activeVal==='1'">
                <el-select v-model="form.type" filterable clearable placeholder="文物类别" style="width:100%;">
                  <el-option
                    v-for="item in typeList"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>

              <div class="search-btn">
                <el-button class="btn" type="primary" @click="handleSearch">搜索</el-button>
              </div>
            </el-form>
          </div>

          <div class="g-card-list mt-30">
            <!-- 瀑布流 -->
            <div class="list-masonry" v-if="activeVal==='1'||activeVal==='3'||activeVal==='4'">
              <div class="colum">
                <div class="item" v-for="(item, index) in data1" :key="index" @click="goDetail(item)">
                  <div class="pic-box">
                    <img v-lazy="item.picture" alt="">
                  </div>
                  <div class="info">
                    <p class="name m-font-2 ell">{{item.name}}</p>
                    <p class="year m-font-3">{{item.year}}</p>
                  </div>
                </div>
              </div>

              <div class="colum">
                <div class="item" v-for="(item, index) in data2" :key="index" @click="goDetail(item)">
                  <div class="pic-box">
                    <img v-lazy="item.picture" alt="">
                  </div>
                  <div class="info">
                    <p class="name m-font-2 ell">{{item.name}}</p>
                    <p class="year m-font-3">{{item.year}}</p>
                  </div>
                </div>
              </div>

              <div class="colum" v-if="!_isMobile">
                <div class="item" v-for="(item, index) in data3" :key="index" @click="goDetail(item)">
                  <div class="pic-box">
                    <img v-lazy="item.picture" alt="">
                  </div>
                  <div class="info">
                    <p class="name m-font-2 ell">{{item.name}}</p>
                    <p class="year m-font-3">{{item.year}}</p>
                  </div>
                </div>
              </div>

              <div class="colum" v-if="!_isMobile">
                <div class="item" v-for="(item, index) in data4" :key="index" @click="goDetail(item)">
                  <div class="pic-box">
                    <img v-lazy="item.picture" alt="">
                  </div>
                  <div class="info">
                    <p class="name m-font-2 ell">{{item.name}}</p>
                    <p class="year m-font-3">{{item.year}}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 藏品征集 -->
            <div class="list-2" v-if="activeVal==='2'">
              <cmpDetail :detailData="detailData"></cmpDetail>
            </div>

            <!-- 古建遗迹 -->
            <!-- <div class="list list-3" v-if="activeVal==='3'">
              <div class="item g-card-2" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
                <div class="pic-box pic1">
                  <img v-lazy="item.picture" alt="">
                  <div class="icon-3d"></div>
                </div>
                <div class="info m-circle">
                  <div>
                    <h2 class="title m-font-3 two-ell">{{item.name}}</h2>
                    <p class="addr m-font-4">{{item.year}}</p>

                    <p class="m-font-6 five-ell">{{item.text}}</p>

                    <div class="g-btn-more m-font-6"><a>查看详情 ></a></div>
                  </div>

                  <p class="m-font-7">
                    <span class="tag">常设展览</span>
                  </p>
                </div>
              </div>
            </div> -->

            <!-- 无数据 -->
            <div class="g-no-data" v-if="dataList.length === 0 && !listLoading && activeVal!=='2'">
              <div class="no-data-bg"></div>
              <p class="txt text-center">暂无数据</p>
            </div>
          </div>


          <cmpMyPagination :currentPage="listQuery.page" :pageSize="listQuery.size" :total="total" @eventPage="eventPage" v-if="activeVal==='1'"></cmpMyPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/collect/index.scss'
export default {
  watch: {
    $route(to, from) {
      if (to.query.pageType != from.query.pageType) {
        this.activeVal = to.query.pageType || '1'
      }
    }
  },
  data() {
    return {
      activeVal: this.$route.query.pageType || '1',
      tabList: [
        {
          name: '藏品数据库',
          val: '1'
        },
        // {
        //   name: '古籍数据库',
        //   val: '3'
        // },
        // {
        //   name: '石刻数据库',
        //   val: '4'
        // },
        {
          name: '藏品征集',
          val: '2'
        },
        // {
        //   name: '古建遗迹',
        //   val: '3'
        // }
      ],
      dataList: [],
      listQuery: {
        page: 1,
        size: 20,
      },
      total: '0',
      listLoading: false,
      form: {
        name: '',
        type: '',
        year: '',
      },
      yearList: [],
      typeList: [],
      // 瀑布流数据
      data1: [], // 第一列
      data2: [], // 第二列
      data3: [],
      data4: [],
      detailData: {}
    }
  },
  methods: {
    getData() {
      console.log(this.activeVal)
      switch(this.activeVal) {
        case '1':
          this.form.type = ''
          this.getData1()
          // this.handleSearch()
          break
        case '2':
          this.getData2()
          break
        // 古籍
         case '3':
          console.log(4456)
          this.form.type = '20'
          this.getData1()
          break
        // 时刻
        case '4':
          this.form.type = '9'
          this.getData1()
          break
      }
    },
    getData1() {
      this.dataList = []
      // if(this.activeVal === '3') {
      //   this.getDataList2()
      //   return
      // }

      this.listLoading = true
      this.$http
        .get('/webapi/collection/list', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.data.records

            // this.dataList = []
            // this.dataList.map((item, index) => {
            //   this.$nextTick(() => {
            //     this.createQrcode(item)
            //   });
            // })
            let i = 0
            let data = res.data.records
            this.data1 = []
            this.data2 = []
            this.data3 = []
            this.data4 = []

            if(this._isMobile) {
              while (i < data.length) {
                this.data1.push(data[i++]);
                if (i < data.length) {
                  this.data2.push(data[i++]);
                }
              }
            } else {
              while (i < data.length) {
                this.data1.push(data[i++]);
                if (i < data.length) {
                  this.data2.push(data[i++]);
                }
                if (i < data.length) {
                  this.data3.push(data[i++]);
                }
                if (i < data.length) {
                  this.data4.push(data[i++]);
                }
              }
            }

            this.total = res.data.total
            
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    getData2() {
      this.$http
        .get('/webapi/collection/collect', {})
        .then(res => {
          if (res.success) {
            this.detailData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // getData3() {
    //   this.listLoading = true
    //   this.$http
    //     .get('/webapi/collection/relics', {
    //       ...this.listQuery,
    //       size: 999
    //     })
    //     .then(res => {
    //       this.listLoading = false
    //       if (res.success) {
    //         let data = res.data
    //         this.dataList = data.records
    //         // this.total = data.total
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     }).catch(err => {
    //     })
    // },
    getDict() {
      this.$http
        .get('/webapi/collection/dict', {})
        .then(res => {
          if (res.success) {
            let data = res.data
            this.yearList = data.year
            this.typeList = data.type
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    handleSearch() {
      this.listQuery.page = 1
      this.getData1()
    },
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.page = 1
      this.getData()
    },
    eventPage(obj) {
      this.listQuery.page = obj.page
      this.listQuery.size = obj.size
      this.getData1()
    },
    goDetail(item) {
      console.log(item)
      this.$router.push({
        path: '/collect/detail',
        query: {id: item.id}
      })
    },
  },
  created() {
    this.getDict()
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.collect-wrap {
  .search-box {
    display: flex;
    .el-form-item {
      margin-right: 20px;
      width: 240px;
      &:nth-child(1) {
        width: 320px;
      }
    }
    .search-btn {
      .btn {
        width: 240px;
      }
    }
  }

  .list-masonry {
    display: flex;
    margin: 0 -10px;
    .colum {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 0 10px;
    }
    .item {
      margin-bottom: 30px;
      cursor: pointer;
      &:hover {
        .pic-box {
          overflow: hidden;
          img {
            transform: scale(1.02);
          }
        }
      }
      .pic-box {
        img {
          width: 100%;
          min-height: 130px;
          transition: all 0.6s;
        }
      }
      .info {
        box-sizing: border-box;
        padding: 16px;
        height: 122px;
        box-sizing: border-box;
        background: url(~@images/card-bg-collect.png) no-repeat;
        background-size: 100% 100%;
        color: #3D3D3D;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          width: 268px;
          color: $primary;
        }
        .year {
        }
      }
    }
  }

  .list-3 {
    .item {
      .info {
        h2 {
          color: $primary;
        }
        .addr {
          color: #3D3D3D;
        }
      }
      &:nth-child(2n) {
        flex-direction: row-reverse;
        .info {
          background: url(~@images/card-3-l.png);
          background-size: 100% 100%;
        }
      }
    }

    .g-btn-more {
      margin-top: 16px;
      color: $primary;
    }
  }
}
</style>


